/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TicketEventDetail } from './TicketEventDetail';
import {
    TicketEventDetailFromJSON,
    TicketEventDetailFromJSONTyped,
    TicketEventDetailToJSON,
    TicketEventDetailToJSONTyped,
} from './TicketEventDetail';

/**
 * 
 * @export
 * @interface ResultOfIReadOnlyListOfTicketEventDetail
 */
export interface ResultOfIReadOnlyListOfTicketEventDetail {
    /**
     * 
     * @type {Array<TicketEventDetail>}
     * @memberof ResultOfIReadOnlyListOfTicketEventDetail
     */
    data: Array<TicketEventDetail> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResultOfIReadOnlyListOfTicketEventDetail
     */
    isSuccess: boolean;
    /**
     * 
     * @type {Error}
     * @memberof ResultOfIReadOnlyListOfTicketEventDetail
     */
    error: Error | null;
}

/**
 * Check if a given object implements the ResultOfIReadOnlyListOfTicketEventDetail interface.
 */
export function instanceOfResultOfIReadOnlyListOfTicketEventDetail(value: object): value is ResultOfIReadOnlyListOfTicketEventDetail {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('isSuccess' in value) || value['isSuccess'] === undefined) return false;
    if (!('error' in value) || value['error'] === undefined) return false;
    return true;
}

export function ResultOfIReadOnlyListOfTicketEventDetailFromJSON(json: any): ResultOfIReadOnlyListOfTicketEventDetail {
    return ResultOfIReadOnlyListOfTicketEventDetailFromJSONTyped(json, false);
}

export function ResultOfIReadOnlyListOfTicketEventDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfIReadOnlyListOfTicketEventDetail {
    if (json == null) {
        return json;
    }
    return {
        
        'data': (json['data'] == null ? null : (json['data'] as Array<any>).map(TicketEventDetailFromJSON)),
        'isSuccess': json['isSuccess'],
        'error': json['error'],
    };
}

export function ResultOfIReadOnlyListOfTicketEventDetailToJSON(json: any): ResultOfIReadOnlyListOfTicketEventDetail {
    return ResultOfIReadOnlyListOfTicketEventDetailToJSONTyped(json, false);
}

export function ResultOfIReadOnlyListOfTicketEventDetailToJSONTyped(value?: ResultOfIReadOnlyListOfTicketEventDetail | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': (value['data'] == null ? null : (value['data'] as Array<any>).map(TicketEventDetailToJSON)),
        'isSuccess': value['isSuccess'],
        'error': value['error'],
    };
}

